import React from 'react';
import { defineMessages } from 'react-intl';

import DialogConfirm, { DialogConfirmProps } from './DialogConfirm';

const messages = defineMessages({
  deleteInsuranceDialogTitle: {
    id: 'components.v2.DialogInsuranceDelete.deleteInsuranceDialogTitle',
    defaultMessage: 'Delete Insurance',
  },
  deleteInsuranceDialogContent: {
    id: 'components.v2.DialogInsuranceDelete.deleteInsuranceDialogContent',
    defaultMessage: 'Are you sure you’d like to delete this insurance information?',
  },
  deleteInsuranceDialogCancel: {
    id: 'components.v2.DialogInsuranceDelete.deleteInsuranceDialogCancel',
    defaultMessage: 'Cancel',
  },
  deleteInsuranceDialogConfirm: {
    id: 'components.v2.DialogInsuranceDelete.deleteInsuranceDialogConfirm',
    defaultMessage: 'Delete',
  },
});

interface DialogInsuranceDeleteProps
  extends Omit<DialogConfirmProps, 'title' | 'content' | 'confirmButton' | 'cancelButton'> {}

const DialogInsuranceDelete: React.FC<DialogInsuranceDeleteProps> = ({ handleCancel, handleConfirm, ...rest }) => (
  <DialogConfirm
    title={messages.deleteInsuranceDialogTitle}
    content={messages.deleteInsuranceDialogContent}
    cancelButton={messages.deleteInsuranceDialogCancel}
    confirmButton={messages.deleteInsuranceDialogConfirm}
    handleCancel={handleCancel}
    handleConfirm={handleConfirm}
    {...rest}
  />
);

export default DialogInsuranceDelete;
